import { getLocalTranslation } from '../../utils/i18nKit';
export var getQuoteDiscountReasonList = function getQuoteDiscountReasonList() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return [{
    value: 'Jove Promotion - Match',
    label: $t('kit:quoteDiscountReason.jove_promotion_match')
  }, {
    value: 'Competitor Price - Match',
    label: $t('kit:quoteDiscountReason.competitor_price_match')
  }, {
    value: 'UW Agreed',
    label: $t('kit:quoteDiscountReason.uw_agreed')
  }, {
    value: 'Loyalty Concession',
    label: $t('kit:quoteDiscountReason.loyalty_concession')
  }, {
    value: 'Sales Discretionary',
    label: $t('kit:quoteDiscountReason.sales_discretionary')
  }, {
    value: 'Switch to Jove',
    label: $t('page:ProductsBar.switch_to_jove')
  }];
};
export var getQuoteCreationMethodList = function getQuoteCreationMethodList() {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  return [{
    value: 'system',
    label: $t('kit:quoteCreationMethod.system_generated')
  }, {
    value: 'manual',
    label: $t('kit:quoteCreationMethod.manually_generated')
  }];
};
export var getBrokerQuoteNotesStatusMap = function getBrokerQuoteNotesStatusMap() {
  return {
    pendingFromJove: {
      value: 'pending_from_jove',
      label: 'Pending from Jove'
    },
    pendingFromBroker: {
      value: 'pending_from_broker',
      label: 'Pending from broker'
    },
    allNotes: {
      value: 'all_notes',
      label: 'All notes'
    }
  };
};
export var getBrokerQuoteNotesStatusList = function getBrokerQuoteNotesStatusList() {
  return Object.values(getBrokerQuoteNotesStatusMap());
};